module.exports = __webpack_public_path__ + "img/consultant.b54a1f52.png";